import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { env } from '../../environments/environment';
import { InspectionItem, InspectionVersion, ListFilters, Section } from '../shared/interfaces';

@Injectable({
  providedIn: 'root',
})
export class ItemService {
  constructor(protected http: HttpClient) {}

  list(filters: ListFilters) {
    return this.http.get<InspectionItem[]>(`${env.APIUrl}/inspectionItem`, { params: filters as any });
  }

  get(id: number, versionName: string) {
    return this.http.get<InspectionItem>(`${env.APIUrl}/inspectionItem/${id}`, { params: { versionName } }).toPromise();
  }

  sections(itemId: number, versionName: string) {
    return this.http.get<Section[]>(`${env.APIUrl}/inspectionItem/${itemId}/sections`, { params: { versionName } });
  }

  edit(itemId: number, item: InspectionItem, versionName: string) {
    return this.http
      .put<InspectionItem>(`${env.APIUrl}/inspectionItem/${itemId}`, item, { params: { versionName } })
      .toPromise();
  }

  create(item: InspectionItem, versionName: string) {
    return this.http
      .post<InspectionItem>(`${env.APIUrl}/inspectionItem`, item, { params: { versionName } })
      .toPromise();
  }

  remove(itemId: number, versionName: string) {
    return this.http
      .delete<InspectionVersion>(`${env.APIUrl}/inspectionItem/${itemId}`, { params: { versionName } })
      .toPromise();
  }

  move(version: InspectionVersion, id: number, newPosition: number) {
    return this.http.post<boolean>(`${env.APIUrl}/inspectionItem/${id}/move`, { newPosition, version }).toPromise();
  }

  clone(itemId: number, versionName: string) {
    return this.http
      .post<InspectionVersion>(`${env.APIUrl}/inspectionItem/${itemId}/clone`, null, { params: { versionName } })
      .toPromise();
  }
}
